function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import SearchAdornment from './SearchAdornment';
import TextBox from './TextBox';
import '../assets/inputFields.css';
const SearchBox = props => /*#__PURE__*/React.createElement(TextBox, _extends({}, props, {
  key: props.name || +new Date(),
  InputProps: {
    startAdornment: /*#__PURE__*/React.createElement(SearchAdornment, null)
  }
}));
SearchBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string
};
export default SearchBox;